import React, { Fragment } from 'react'
import { Product, ProductItemOpt } from '../../../../../helpers/models/Models'
import { MasterCategoryOptions, SubCategoryOptions, UnitOptions, YesNoOptions } from '../../../../../constants/Options';
import { NepNowDateFormat } from '../../../../../constants/DateFormat';
import { postDataToTheServer, putDataToTheServer } from '../../../../../helpers/api';
import AppURL from '../../../../../constants/AppURL';
import { ToastSuccess, ToastWarning } from '../../../../../constants/Toast';
import useFetchSubData from '../../../../../helpers/useSubFetch';
import Container from '../../../../../constants/Container';
import SecHeading from '../../../../../constants/SecHeading';
import { Grid } from '@mui/material';
import DefaultSelectInputBox from '../../../../../constants/DefaultSelectBox';
import { handleNepaliInputChange, handleSelectBox } from '../../../../../helpers/handleChange';
import { RiProductHuntLine } from 'react-icons/ri';
import InputTextBox from '../../../../../constants/InputTextBox';
import NepaliInputBox from '../../../../../constants/NepaliInputBox';
import { MdCurrencyRupee, MdPercent } from 'react-icons/md';
import { GiTakeMyMoney } from 'react-icons/gi';
import { CiBarcode } from 'react-icons/ci';
import { EndBaseLine } from '../../../../../constants/AppSpace';
import { Button } from '../../../../../constants/Button';
import { useFormik } from 'formik';
import useFetchData from '../../../../../helpers/useFetch';
import DialogBox from '../../../../../constants/DialogBox';

interface ProductEditViewProps {
  currentItem: Product | null;
  dialogOpen: boolean;
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleFormSuccess: () => void;
}

const ProductEditView: React.FC<ProductEditViewProps> = ({ currentItem, handleFormSuccess, setDialogOpen, dialogOpen }) => {
  const { data: data_opt, loading: loading_opt, error: error_opt, refetch: refetch_opt } = useFetchData(AppURL.InventoryURL + "inventory/product/create/options/list/view/");

  const categoryMaterOption = MasterCategoryOptions(data_opt?.master_category);
  const unitOptions = UnitOptions(data_opt?.product_unit);
  const initialValues = {
    master_category: currentItem?.product_master || "",
    sub_master: currentItem?.sub_master || "",
    purchase_unit: currentItem?.purchase_unit || "",
    sales_unit: currentItem?.sales_unit || "",
    pro_name: currentItem?.pro_name || "",
    pro_name_nep: currentItem?.pro_name_nep || "",
    pur_rate: currentItem?.pur_rate || "",
    sales_rate: currentItem?.sales_rate || "",
    pro_notes: currentItem?.pro_notes || "",
    status: currentItem?.status?.toString() === "1" ? "1" : "2" || "",
    opening_stock: currentItem?.opening_stock || "",
    stock_limit_qty: currentItem?.stock_limit_qty || "",
    discable: currentItem?.discable?.toString() === "1" ? "1" : "2" || "",
    disc_perc: currentItem?.disc_perc || "",
    disc_amt: currentItem?.disc_amt || "",
    model_no: currentItem?.model_no || "",
    char_code: currentItem?.char_code || "",
    sizes: currentItem?.sizes || "",
    mat_type: currentItem?.mat_type || "",
    vat_perc: currentItem?.vat_perc || "",
    with_vat: currentItem?.with_vat?.toString()=== "1" ? "1" : "2" || "",
  }
  const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: async (values, action) => {
      const formData = new FormData();
      Object.keys(values).forEach((key) => {
        const value = (values as Record<string, any>)[key];
        if (value !== undefined && value !== null && value !== "") {
          formData.append(key, value);
        }
      });
      // Handle specific field conditions
      (["discable", "status", "with_vat"] as Array<keyof typeof values>).forEach(key => {
        const value = values[key];
        if (key === "discable" && value === "2") {
          formData.append("disc_perc", "");
          formData.append("disc_amt", "");
        } else if (key === "with_vat" && value === "2") {
          formData.append("vat_perc", "");
        } else {
          formData.append(key, value === "1" ? "1" : "0");
        }
      });

      try {
        await putDataToTheServer(AppURL.InventoryURL + 'inventory/product/item/retrieve/update/view/' + currentItem?.sn, formData).then((res) => {
          if (res?.status === 200) {
            action.resetForm();
            setDialogOpen(false);
            handleFormSuccess();
            ToastSuccess({ message: res?.message });
          } else if (res?.status === 400) {
            ToastWarning({ message: res?.message });
          }
          else {
            ToastWarning({ message: "Some Issue" });
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
  });
  const { data, loading, error } = useFetchSubData(AppURL.InventoryURL + "inventory/product/category/master/wise/list/?product_master=" + values.master_category, values.master_category);
  const subCategoryOptions = SubCategoryOptions(data?.sub_category);
  return (
    <DialogBox headerName='Product Edit Add' open={dialogOpen} close={() => setDialogOpen(false)}>
      <form onSubmit={handleSubmit}>
        <Grid container columnSpacing={2} rowSpacing={0.8}>
          <Grid item xl={4} lg={4} sm={6} md={4} xs={12}>
            <DefaultSelectInputBox
              label='Master Category'
              options={categoryMaterOption}
              optionSelect={(name, selectedOption) => {
                setFieldValue(name, selectedOption.value);
              }}
              required={true}
              disabled
              placeholder='Select Master category'
              name='master_category'
              handleBlur={() => {
                handleBlur({ target: { name: 'master_category' } });
              }}
              value={values.master_category}
              touched={touched.master_category}
              errors={errors.master_category}
            />
          </Grid>
          <Grid item xl={4} lg={4} sm={6} md={4} xs={12}>
            <DefaultSelectInputBox
              label='Sub Category'
              options={subCategoryOptions}
              optionSelect={(name, selectedOption) => {
                setFieldValue(name, selectedOption.value);
              }}
              required={true}
              placeholder='Select Sub category'
              name='sub_master'
              handleBlur={() => {
                handleBlur({ target: { name: 'sub_master' } });
              }}
              value={values.sub_master}
              touched={touched.sub_master}
              errors={errors.sub_master}
            />
          </Grid>
          <Grid item xl={4} lg={4} sm={6} md={4} xs={12}>
            <InputTextBox
              type='text'
              prefix={<RiProductHuntLine />}
              name='pro_name'
              label='Product Name'
              handleChange={handleChange}
              value={values.pro_name}
              error={errors.pro_name}
              handleBlur={handleBlur}
              touched={touched.pro_name}
              required={true}
              placeholder='Enter Product Name'
            />
          </Grid>
          <Grid item xl={4} lg={4} sm={6} md={4} xs={12}>
            <NepaliInputBox
              label='Product Name(Nepali)'
              name='pro_name_nep'
              value={values.pro_name_nep}
              handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'pro_name_nep' })}
              required={true}
              handleBlur={handleBlur}
              error={errors.pro_name_nep}
              placeholder='Enter Product nepali'
              touched={touched.pro_name_nep}
            />
          </Grid>
          <Grid item xl={4} lg={4} sm={6} md={4} xs={12}>
            <InputTextBox
              prefix={<MdCurrencyRupee />}
              type='number'
              name='pur_rate'
              label='Purchase Rate'
              handleChange={handleChange}
              value={values.pur_rate}
              error={errors.pur_rate}
              handleBlur={handleBlur}
              touched={touched.pur_rate}
              required={true}
              placeholder='Enter Purchase Rate'
            />
          </Grid>
          <Grid item xl={4} lg={4} sm={6} md={4} xs={12}>
            <InputTextBox
              type='number'
              prefix={<MdCurrencyRupee />}
              name='sales_rate'
              label="Sales Rate"
              handleChange={handleChange}
              value={values.sales_rate}
              error={errors.sales_rate}
              handleBlur={handleBlur}
              touched={touched.sales_rate}
              required={true}
              placeholder='Enter Sales Rate'
            />
          </Grid>

          <Grid item xl={4} lg={4} sm={6} md={4} xs={12}>
            <DefaultSelectInputBox
              label='Purchase Unit'
              options={unitOptions}
              optionSelect={(name, selectedOption) => {
                setFieldValue(name, selectedOption.value);
              }}
              required={true}
              placeholder='Select Purchase Unit'
              name='purchase_unit'
              handleBlur={() => {
                handleBlur({ target: { name: 'purchase_unit' } });
              }}
              value={values.purchase_unit}
              touched={touched.purchase_unit}
              errors={errors.purchase_unit}
            />
          </Grid>
          <Grid item xl={4} lg={4} sm={6} md={4} xs={12}>
            <DefaultSelectInputBox
              label='Sales Unit'
              options={unitOptions}
              optionSelect={(name, selectedOption) => {
                setFieldValue(name, selectedOption.value);
              }}
              required={true}
              placeholder='Select Sales Unit'
              name='sales_unit'
              handleBlur={() => {
                handleBlur({ target: { name: 'sales_unit' } });
              }}
              value={values.sales_unit}
              touched={touched.sales_unit}
              errors={errors.sales_unit}
            />
          </Grid>
          <Grid item xl={4} lg={4} sm={6} md={4} xs={12}>
            <InputTextBox
              type='number'
              name='opening_stock'
              label='Opening Stock'
              handleChange={handleChange}
              value={values.opening_stock}
              error={errors.opening_stock}
              handleBlur={handleBlur}
              touched={touched.opening_stock}
              required={false}
              placeholder='Enter Opening Stock'
            />
          </Grid>
          <Grid item xl={4} lg={4} sm={6} md={4} xs={12}>
            <InputTextBox
              type='number'
              name='stock_limit_qty'
              label='Stock Limit QTY'
              handleChange={handleChange}
              value={values.stock_limit_qty}
              error={errors.stock_limit_qty}
              handleBlur={handleBlur}
              touched={touched.stock_limit_qty}
              required={false}
              placeholder='Enter Stock Limit QTY'
            />
          </Grid>
          <Grid item xl={4} lg={4} sm={6} md={4} xs={12}>
            <DefaultSelectInputBox
              label='With VAT'
              options={YesNoOptions}
              optionSelect={(name, selectedOption) => {
                setFieldValue(name, selectedOption.value);
              }}
              required={true}
              placeholder='Select Options'
              name='with_vat'
              handleBlur={() => {
                handleBlur({ target: { name: 'with_vat' } });
              }}
              value={values.with_vat}
              touched={touched.with_vat}
              errors={errors.with_vat}
            />
          </Grid>
          {
            values.with_vat === "1" &&
            <Grid item xl={4} lg={4} sm={6} md={4} xs={12}>
              <InputTextBox
                prefix={<MdPercent />}
                type='number'
                name='vat_perc'
                label='VAT Percentage'
                handleChange={handleChange}
                value={values.vat_perc}
                error={errors.vat_perc}
                handleBlur={handleBlur}
                touched={touched.vat_perc}
                required={false}
                placeholder='Enter VAT Percentage'
              />
            </Grid>
          }
          <Grid item xl={4} lg={4} sm={6} md={4} xs={12}>
            <DefaultSelectInputBox
              label='Discount'
              options={YesNoOptions}
              optionSelect={(name, selectedOption) => {
                setFieldValue(name, selectedOption.value);
              }}
              required={true}
              placeholder='Select Discount'
              name='discable'
              handleBlur={() => {
                handleBlur({ target: { name: 'Discount' } });
              }}
              value={values.discable}
              touched={touched.discable}
              errors={errors.discable}
            />
          </Grid>
          {
            values.discable === "1" && <Fragment>
              <Grid item xl={4} lg={4} sm={6} md={4} xs={12}>
                <InputTextBox
                  prefix={<MdPercent />}
                  type='number'
                  name='disc_perc'
                  label='Discount Percentage'
                  handleChange={handleChange}
                  value={values.disc_perc}
                  error={errors.disc_perc}
                  handleBlur={handleBlur}
                  touched={touched.disc_perc}
                  disabled={values.disc_amt!==""}
                  required={false}
                  placeholder='Enter Discount Percentage'
                />
              </Grid>
              <Grid item xl={4} lg={4} sm={6} md={4} xs={12}>
                <InputTextBox
                  prefix={<GiTakeMyMoney />}
                  type='number'
                  name='disc_amt'
                  label='Discount Amount'
                  handleChange={handleChange}
                  value={values.disc_amt}
                  error={errors.disc_amt}
                  handleBlur={handleBlur}
                  disabled={values.disc_perc!==""}
                  touched={touched.disc_amt}
                  required={false}
                  placeholder='Enter Discount Amount'
                />
              </Grid>
            </Fragment>
          }
          <Grid item xl={4} lg={4} sm={6} md={4} xs={12}>
            <InputTextBox
              type='text'
              name='model_no'
              label='Model No.'
              handleChange={handleChange}
              value={values.model_no}
              error={errors.model_no}
              handleBlur={handleBlur}
              touched={touched.model_no}
              required={false}
              placeholder='Enter Model No.'
            />
          </Grid>
          <Grid item xl={4} lg={4} sm={6} md={4} xs={12}>
            <InputTextBox
              type='text'
              name='char_code'
              prefix={<CiBarcode />}
              label='Product Code'
              handleChange={handleChange}
              value={values.char_code}
              error={errors.char_code}
              handleBlur={handleBlur}
              touched={touched.char_code}
              required={false}
              placeholder='Enter Product Code'
            />
          </Grid>
          <Grid item xl={4} lg={4} sm={6} md={4} xs={12}>
            <InputTextBox
              type='number'
              name='sizes'
              label='Product Sizes'
              handleChange={handleChange}
              value={values.sizes}
              error={errors.sizes}
              handleBlur={handleBlur}
              touched={touched.sizes}
              required={false}
              placeholder='Enter Product Sizes'
            />
          </Grid>
          <Grid item xl={4} lg={4} sm={6} md={4} xs={12}>
            <InputTextBox
              type='text'
              name='pro_notes'
              label='Product Notes'
              handleChange={handleChange}
              value={values.pro_notes}
              error={errors.pro_notes}
              handleBlur={handleBlur}
              touched={touched.pro_notes}
              required={false}
              placeholder='Enter Product Notes'
            />
          </Grid>
          <Grid item xl={4} lg={4} sm={6} md={4} xs={12}>
            <DefaultSelectInputBox
              label='Active'
              options={YesNoOptions}
              optionSelect={(name, selectedOption) => {
                setFieldValue(name, selectedOption.value);
              }}
              required={true}
              placeholder='Select active/inactive'
              name='status'
              handleBlur={() => {
                handleBlur({ target: { name: 'status' } });
              }}
              value={values.status}
              touched={touched.status}
              errors={errors.status}
            />
          </Grid>
          <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
            <EndBaseLine top={0}>
              <Button btn_type='update' type='submit' el='button' />
            </EndBaseLine>
          </Grid>
        </Grid>
      </form>

    </DialogBox>
  )
}

export default ProductEditView;
